<template>
  <div class="tag-student">
    <search placeholder="请输入标签名字" @search="search" />
    <div class="tag-list">
      <el-radio-group v-model="selectLabelId">
        <el-radio
          :label="item.id"
          class="tag-item"
          v-for="item in labelConditionList"
          :key="item.id"
          >{{ item.labelName }}</el-radio
        >
      </el-radio-group>
    </div>
    <div class="btn-list">
      <el-button type="primary" plain @click="back">返回</el-button>
      <el-button type="primary" @click="tagStudentSubmit">确认</el-button>
    </div>
  </div>
</template>

<script>
import search from "@/components/search/search.vue";
export default {
  props: ["isChooseContainerShow", "labelConditionList", "comparativeExamData", "gradeStudentList"],
  components: {
    search,
  },
  data() {
    return {
      selectLabelId: "",
    };
  },
  methods: {
    // 选择标签学生成绩对比点击提交
    tagStudentSubmit() {
      // console.log(this.comparativeExamData);
      if (this.selectLabelId == "") return this.$message.warning("请选择标签");
      let list = [];
      list.push(this.selectLabelId);
      const comparativeExamArray = this.comparativeExamData.map(
        (item) => item.id
      );
      let data = {
        // oneExamInfoId: this.comparativeExamData[0].id,
        // twoExamInfoId: this.comparativeExamData[1].id,
        examInfoIds: comparativeExamArray,
        labelIds: list,
        gradeId: this.gradeStudentList[0].gradeId 
      };
      this.$emit("tagStudentSubmit", data);
    },
    // 返回选择方式
    back() {
      this.selectLabelId = "";
      this.$emit("update:isChooseContainerShow", true);
    },
    // 搜索标签名称
    search(e) {
      this.$emit("searchLabelName", e);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./tagStudent.scss";
</style>